export function parseDatasetToProps(dataset) {
    const props = {};

    // Parse dataset to valid props
    for (const key in dataset) {
        props[key] = dataset[key];

        // Try to parse string to literal
        // Will parse: array, boolean, null, number, object and string
        try {
            props[key] = JSON.parse(props[key]);
        } catch (e) { } // eslint-disable-line no-empty
    }

    return props;
}
